import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router'
import { Link as RouterLink } from 'react-router-dom'
import { Grid, Typography, Link, Box } from '@material-ui/core'
import { showCommunity } from 'api/communities'
import GoogleAuthenticate from 'components/Authenticate/GoogleAuthenticate'
import FacebookAuthenticate from 'components/Authenticate/FacebookAuthenticate'
import OrDivider from 'components/Authenticate/OrDivider'
import SignUpForm from 'components/Invite/SignUpForm'
import { invitePageViewed } from 'utils/mixpanel'

export default function Invite() {
  const [community, setCommunity] = useState({})
  const { communityId } = useParams()
  useEffect(() => {
    showCommunity(communityId).then(({ data: { result, entities: { communities }  } }) => {
      setCommunity(communities[result])
      invitePageViewed()
    })
  }, [communityId])

  const history = useHistory()
  const redirectToOnboarding = () => { history.replace('/supporter-onboarding') }

  const { name, logoUrl } = community

  return (
    <Grid container spacing={3} alignItems='center'>
      {/* TODO: graceful loading? */}
      <Grid item xs={12} sm={6} md={8}>
        <Box component='img' src={logoUrl} width={1} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Typography align='center' variant='h4' component='h1'>
          {name}
        </Typography>
        <Typography paragraph align='center' variant='h6' component='h1'>
          Join our giving community on Sixpence
        </Typography>
        <GoogleAuthenticate type='signUp' communityId={communityId} onSuccessCallback={redirectToOnboarding} />
        <FacebookAuthenticate type='signUp' communityId={communityId} onSuccessCallback={redirectToOnboarding} />
        <OrDivider />
        <SignUpForm { ...{ communityId, onSuccessCallback: redirectToOnboarding } } />
        <Typography variant='body2'>Already joined? <Link component={RouterLink} to='/login'>Log In</Link></Typography>
      </Grid>
    </Grid>
  )
}
